<template>
<div>
  <pre class="rsync-script-cmd">{{ cmd }}</pre>
  <div class="field">
    <a class="button is-primary" :href="scriptOutput" download="rsync_ninja_backup.sh">Download script</a>
  </div>
</div>
</template>

<script>
export default {
  name: "rsync-script",
  props: {
    cmd: String
  }, 
  computed: {
    scriptOutput() {

      return 'data:text/plain;charset=utf-8,' + this.cmd
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.rsync-script {
  // border-top: 1px solid red;
}

.rsync-script-cmd {
  margin-bottom: 1rem;
  // display: inline-block;
  // width: 100%;
}
</style>
